import React, { Component } from 'react';
import styles from './style.css';

class AdPause extends Component {
    constructor() {
        super();
        this.state = {
            showItem: false,
            isRender: true,
        };
    }
    hide() {
        this.setState({
            showItem: false,
        });
    }
    show() {
        this.setState({
            showItem: true,
        });
    }
    // 隐藏成为VIP广告
    adVipClose() {
        this.setState({
            showItem: false,
        });
    }
    // 显示成为vip广告      会把固定的图片插入到暂停的位置
    adVip(src) {
        src = src || '//p1.ifengimg.com/a/2016/1021/pause.jpg?vip1';
        let _adDom = null;

        if (src.indexOf('.jpg') > -1) {
            _adDom = <img src={src} />;
        } else {
            _adDom = <iframe src={src} width="100%" height="100%" scrolling="no" frameBorder="no" border="0" />;
        }

        this.vipChildren = _adDom;
        this.setState({
            showItem: true,
            renderVip: true,
        });
    }
    destory() {
        this.setState({
            isRender: false,
        });
    }
    componentDidMount() {
        this.pauseClose = this.refs['pauseClose'];
        this.pauseClose.onclick = () => {
            this.setState({
                showItem: false,
            });
        };
    }
    render() {
        const { isRender, showItem, renderVip } = this.state;
        const _adPause = isRender ? (
            <div
                style={{ display: showItem ? 'block' : 'none' }}
                className={styles.videopause}
                id="js_videopause_container">
                <div className={styles.videoPauseLayout}>
                    <div className={styles.videoPausePosition}>
                        <a
                            href="javascript:void(0)"
                            className={styles.videoPauseClose}
                            ref="pauseClose"
                            data-tag="pauseclose">
                            <span className={styles.videoPauseCloseIcon} />
                            <span className={styles.videoPauseCloseText} ref="pauseClose">
                                关闭广告
                            </span>
                        </a>
                        <a
                            href="javascript:void(0)"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.videoPauseContent}
                            ref={c => {
                                this.pauseLink = c;
                            }}
                            data-tag="pauselink">
                            {renderVip ? this.vipChildren : null}
                        </a>
                    </div>
                </div>
            </div>
        ) : null;

        return _adPause;
    }
}

export default AdPause;
